import { render, staticRenderFns } from "./crudLeadsSellers.vue?vue&type=template&id=270b0756"
import script from "./crudLeadsSellers.vue?vue&type=script&lang=js"
export * from "./crudLeadsSellers.vue?vue&type=script&lang=js"
import style0 from "./crudLeadsSellers.vue?vue&type=style&index=0&id=270b0756&prod&lang=css"
import style1 from "./crudLeadsSellers.vue?vue&type=style&index=1&id=270b0756&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports